import { Link as RouterLink } from 'react-router-dom';
import { Link, Typography } from '@mui/material';
import FormManager from '../../components/formComponents/FormManager';
import schema from './schema.json';

export default function Forgot() {
  return (
    <div style={{ display: 'flex', minHeight: '100vh', width: '100%' }}>

      {/* ── LEFT PANEL ── dark navy */}
      <div style={{
        flex: '0 0 45%',
        backgroundColor: '#0D1727',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
        position: 'relative',
      }}>
        <img
          alt="Astra POS"
          src="/static/icons/login_page.png"
          style={{ maxWidth: '72%', objectFit: 'contain' }}
        />
        <div style={{
          position: 'absolute', bottom: '2rem', left: 0, right: 0,
          display: 'flex', justifyContent: 'space-evenly', alignItems: 'center',
        }}>
          {['Secure Employee Access', 'Real-time Sync', 'Salons & Spa'].map((txt) => (
            <span key={txt} style={{
              color: '#C9A060', fontSize: '0.72rem', letterSpacing: '0.04em',
              fontWeight: 600, backgroundColor: 'rgba(201,160,96,0.1)',
              padding: '4px 10px', borderRadius: '4px',
            }}>{txt}</span>
          ))}
        </div>
      </div>

      {/* ── RIGHT PANEL ── cream */}
      <div style={{
        flex: 1, backgroundColor: '#F7F1E8',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <div style={{
          width: '100%', maxWidth: '420px',
          background: '#ffffff', borderRadius: '20px',
          boxShadow: '0 8px 32px rgba(13,23,39,0.12)',
          padding: '2.5rem 2.5rem 2rem',
          display: 'flex', flexDirection: 'column', alignItems: 'center',
        }}>

          {/* Key icon */}
          <div style={{
            width: '64px', height: '64px', borderRadius: '50%',
            backgroundColor: '#F5E6A0', display: 'flex',
            alignItems: 'center', justifyContent: 'center',
            marginBottom: '1.25rem', fontSize: '1.8rem',
          }}>
            🔑
          </div>

          <Typography variant="h5" style={{ fontWeight: 700, color: '#0D1727', marginBottom: '0.35rem', textAlign: 'center' }}>
            Forgot Password?
          </Typography>
          <Typography variant="body2" style={{ color: '#6B7280', marginBottom: '1.75rem', textAlign: 'center' }}>
            Enter your email and we&apos;ll send you a reset link
          </Typography>

          <div style={{ width: '100%' }}>
            <FormManager formProps={schema} />
          </div>

          <Typography variant="caption" style={{ marginTop: '1.5rem', color: '#9CA3AF', textAlign: 'center' }}>
            Don&apos;t have an account?&nbsp;
            <Link underline="hover" component={RouterLink} to="/register"
              style={{ color: '#C9A060', fontWeight: 600 }}>
              Get started
            </Link>
          </Typography>

        </div>
      </div>

    </div>
  );
}
